import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { useBeaconRemove } from 'Hooks/Common';
import { useDocumentDelete } from 'Hooks/Document';
import { DownloadOption } from 'Interfaces/Auth';
import { Document } from 'Interfaces/Document';
import { RoutePaths } from 'Interfaces/RoutePaths';
import { selectDocument } from 'Utils/selectors';

import { LandingConfirmPage } from './components';

interface LandingSignUpConfirmProps {
  documentId: string;
}

const LandingSignUpConfirm = () => {
  useBeaconRemove();
  const navigate = useNavigate();
  const locationState = useLocation().state as LandingSignUpConfirmProps;

  const [deleteDocument] = useDocumentDelete();
  const [documentId] = useState<Document['id'] | undefined>(locationState.documentId);

  const document = useSelector(state => selectDocument(state, { documentId }));

  const resetForm = (option: DownloadOption) => {
    documentId && deleteDocument({ documentId, isLocalDelete: true });
    navigate(RoutePaths.LANDING_SIGNUP_THANKS, { state: { documentId, option } });
  };

  return (
    <div className="sign-up-landing__wrapper">
      <LandingConfirmPage document={document} onFinish={resetForm} />
    </div>
  );
};

export default LandingSignUpConfirm;
